module.exports = __webpack_public_path__ + "assets/favicon-32x32.9570ab4f.png";